import axios from "axios"
import Vue from "vue"
import Store from "@/store"
import { Notify } from "vant"

const service = axios.create({
  baseURL: "/req"
})
service.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + Store.state.user.token
    const cookie = Vue.ls.get("sCookie")
    if (cookie && config.url === "/api/auth/register") {
      config.headers["s-cookie"] = cookie // 注册判断来源
    }
    return config
  },

  err => {
    console.log(err)
  }
)
service.interceptors.response.use(
  response => {
    const { data } = response
    if (data.status_code === 200) {
      if (response.config.method === "post") {
        data.msg &&
          Notify({
            type: "success",
            message: data.msg
          })
      }
      return data.data
    } else if (data.status_code === 401) {
      Vue.ls.set("token", null)
      location.reload()
      return data
    } else {
      Notify({
        type: "warning",
        message: data.msg
      })
      return Promise.reject(data)
    }
  },
  err => {
    Notify({
      type: "warning",
      message: "网络错误"
    })
    return Promise.reject(err)
  }
)

export default service
